<template>
  <div class="revenue-sharing">
    <div class="revenue-sharing__wrapper">
      <div class="revenue-sharing__wrapper__header">
        <h1 class="large-title">Sharing</h1>
        <div class="revenue-sharing__wrapper__header__functionality">
          <div class="revenue-sharing__wrapper__header__functionality__left">
            <div class="revenue-sharing__wrapper__header__functionality__left__search">
              <i class="adx-ic_search"></i>
              <input type="text" placeholder="Search Campaign" v-model="searchBoxValue">
            </div>
            <div class="revenue-sharing__wrapper__header__functionality__left__status">
              <adx-list-dropdown :list="statusDropdown" :labelButton="`All Status`" @selected="selectStatus"/>
            </div>
          </div>
        </div>
      </div>
      <div class="revenue-sharing__wrapper__list">
        <table>
          <thead>
            <tr>
              <td class="header">Campaign Detail</td>
              <td class="header">Status</td>
              <td class="header">Total Price</td>
              <td class="header">Prop. Disc</td>
              <td class="header">Add. Cost</td>
              <td class="header">Net Price</td>
              <td class="header"></td>
            </tr>
          </thead>
          <tbody v-if="!isLoading && !isEmpty">
            <tr v-for="(list, index) in processedLists" :key="index">
              <td class="body">
                {{ list.campaign }}
                <p class="small-font">{{ formatDate(list.date_start) }} - {{ formatDate(list.date_end) }}</p>
              </td>
              <td class="body" :class="{active : list.status == 'Active', expired : list.status == 'Waiting for Approval', upcoming : list.status == 'upcoming'}">{{ list.status | capitalize}}</td>
              <td class="body">{{ list.total_price | formatMoney}}</td>
              <td class="body">{{ list.discount | formatMoney}}</td>
              <td class="body">{{ list.cost | formatMoney}}</td>
              <td class="body">{{ list.net_price | formatMoney}}</td>
              <td class="body"><menu-expansion :itemID="list.id" :lists="menuList" @selected="selected" /></td>
            </tr>
          </tbody>
          <adx-loading v-if="isLoading" slot="loading" class="loading"/>
          <div v-if="!isLoading && isEmpty">
            <div class="empty">
              <img src="/img/notfound/img-empty-draft@2x.png" alt="">
              <span class="text">Your data is empty.</span>
            </div>
          </div>
        </table>
      </div>
      <modal v-if="isShowCostModal" @modal-close="closeModal" title="Add Cost / Campaign">
        <div slot="content" class="revenue-sharing__wrapper__modal">
          <adx-input :label="`Cost Name`" class="row" :value.sync="model.costName"/>
          <adx-input :label="`Cost Value (Rp)`" class="row" :value.sync="model.costAmount" type="number"/>
          <div class="row2"><span>Sharing Schemes</span></div>
          <div class="row">
            <span>Adx</span>
            <adx-input :label="`Percentage`" class="field" v-model="adxShare" type="number" :disabled="true"/>
          </div>
          <div v-for="(role, index) in model.roles" :key="index" class="row">
            <span v-if="role.role == 1">Host</span>
            <span v-else-if="role.role == 2">Investor</span>
            <span v-else>Consultant</span>
            <adx-input :label="`Percentage`" class="field" :value.sync="role.share" type="number"/>
          </div>
          <div v-if="!isRevenueValid" class="row">
            <span class="error">Total percentage can't be higher than 100%</span>
          </div>
          <div class="buttons2">
            <div class="left"><button @click="addRole">Add more roles</button></div>
            <div class="right">
              <button class="btn-regular secondary" @click="closeModal">Cancel</button>
              <button class="btn-regular primary" @click="setCostSharing" :disabled="!isRevenueValid">Ok</button>
            </div>
          </div>
        </div>
      </modal>
      <modal v-if="isShowRevenueModal" @modal-close="closeModal" title="Revenue Sharing Scheme">
        <div slot="content" class="revenue-sharing__wrapper__modal">
          <div class="row">
            <span>Adx</span>
            <adx-input :label="`Percentage`" class="field" v-model="adxShare" type="number" :disabled="true"/>
          </div>
          <div v-for="(role, index) in model.roles" :key="index" class="row">
            <span v-if="role.role == 1">Host</span>
            <span v-else-if="role.role == 2">Investor</span>
            <span v-else>Consultant</span>
            <adx-input :label="`Percentage`" class="field" :value.sync="role.share" type="number"/>
          </div>
          <div v-if="!isRevenueValid" class="row">
            <span class="error">Total percentage can't be higher than 100%</span>
          </div>
          <div class="buttons2">
            <div class="left"><button @click="addRole">Add more roles</button></div>
            <div class="right">
              <button class="btn-regular secondary" @click="closeModal">Cancel</button>
              <button class="btn-regular primary" @click="setRevenueSharing" :disabled="!isRevenueValid">Ok</button>
            </div>
          </div>
        </div>
      </modal>
      <modal v-if="isShowDiscountModal" @modal-close="closeModal" title="Proposed Discount">
        <div slot="content" class="revenue-sharing__wrapper__modal">
          <div class="row">
            <adx-input :label="`Discount Value (Rp)`" class="field2" v-model="model.discount" type="number" :disabled="true"/>
          </div>
          <div class="row2"><span>Sharing Schemes</span></div>
          <div class="row">
            <span>Adx</span>
            <adx-input :label="`Percentage`" class="field" v-model="adxShare" type="number" :disabled="true"/>
          </div>
          <div v-for="(role, index) in model.roles" :key="index" class="row">
            <span v-if="role.role == 1">Host</span>
            <span v-else-if="role.role == 2">Investor</span>
            <span v-else>Consultant</span>
            <adx-input :label="`Percentage`" class="field" :value.sync="role.share" type="number"/>
          </div>
          <div v-if="!isRevenueValid" class="row">
            <span class="error">Total percentage can't be higher than 100%</span>
          </div>
          <div class="buttons2">
            <div class="left"><button @click="addRole">Add more roles</button></div>
            <div class="right">
              <button class="btn-regular secondary" @click="closeModal">Cancel</button>
              <button class="btn-regular primary" @click="setDiscountSharing" :disabled="model.discount == 0">Ok</button>
            </div>
          </div>
        </div>
      </modal>
      <modal v-if="isShowRoleModal" @modal-close="closeRoleModal" title="Add User Role">
        <div slot="content" class="revenue-sharing__wrapper__modal">
          <div>
            <adx-select-dropdown :label="`User`" :options="userOptions" class="dropdown" :value.sync="newUser"/>
            <adx-select-dropdown :label="`Role`" :options="roleOptions" class="dropdown" :value.sync="newRole"/>
          </div>
          <div class="buttons1">
            <button class="btn-regular secondary" @click="closeRoleModal">Cancel</button>
            <button class="btn-regular primary" @click="saveNewRole">Save</button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import SelectDropdown from '@/components/Form/SelectDropdown'
import DropdownList from '@/components/Dropdown/ListDropdown'
import MenuExpansion from '@/components/MenuExpansion'
import Loading from '@/components/Loading/Primary'
import Modal from '@/components/Modal'
import Checkbox from '@/components/Form/Checkbox'
import Input from '@/components/Form/Input'
import * as validationLib from '@/lib/validation/'
const {
  helpers,
  validate
} = validationLib

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-revenue-sharing',
  components: {
    'adx-list-dropdown': DropdownList,
    'adx-select-dropdown': SelectDropdown,
    'menu-expansion': MenuExpansion,
    'adx-loading': Loading,
    'adx-checkbox': Checkbox,
    'adx-input': Input,
    Modal,
  },
  props: {

  },
  data() {
    return {
      selectedStatus: '',
      searchBoxValue: '',
      statusSelected: 'allstat',
      isLoading: false,
      isEmpty: false,
      isShowCostModal: false,
      isShowRevenueModal: false,
      isShowDiscountModal: false,
      isShowRoleModal: false,
      isRevenueValid: true,
      newRole: null,
      newUser: null,
      lists: [],
      userOptions: [],
      processedLists: [],
      invoiceDiscount: null,
      model: {
        id: null,
        costName: null,
        costAmount: null,
        discount: null,
        roles: []
      },
      statusDropdown: [
        {
          id: 0,
          label: 'All Status',
          value: ''
        },
        {
          id: 1,
          label: 'Upcoming',
          value: 'upcoming'
        },
        {
          id: 2,
          label: 'Waiting for Approval',
          value: 'Waiting for Approval'
        },
      ],
      menuList: [
        {
          id: 0,
          name: 'Set Revenue Sharing'
        },
        {
          id: 1,
          name: 'Set Discount Sharing'
        },
        {
          id: 2,
          name: 'Set Additional Cost'
        },
      ],
      roleOptions: [
        {
          value: 1,
          label: 'Host'
        },
        {
          value: 2,
          label: 'TV Investor'
        },
        {
          value: 3,
          label: 'Consultant'
        },
      ],
    }
  },
  computed: {
    adxShare: function () {
      let otherShare = 0
      this.model.roles.map(role => {
        otherShare += parseInt(role.share)
      })

      let totalShare = 100 - otherShare

      totalShare < 0 ? this.isRevenueValid = false : this.isRevenueValid = true

      return totalShare
    }
  },
  watch: {
    searchBoxValue: helpers.debounce(function() {
      this.$nextTick(() => {
        this.filterData()
      })
    }, 500),
    selectedStatus: function() {
      this.$nextTick(() => {
        this.filterData()
      })
    },
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.initialLoad()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    initialLoad() {
      (async () => {
        this.isLoading = true

        const { data } = await api.get(apiV2.sharing, { needToken: true })
        this.lists = data
        this.processedLists = data

        const userData = await api.get(apiV2.users, { needToken: true })
        userData.data.map(user => {
          this.userOptions.push(
            {
              value: user.id,
              label: user.email
            }
          )
        })

        this.isLoading = false
      })();
    },
    selected(obj) {
      this.model.roles = []
      this.model.id = obj.item_id

      if (obj.id == 0) {
        // this.isShowRevenueModal = !this.isShowRevenueModal
        this.$router.push({ name: 'revenue', params: { id: obj.item_id }})
      } else if (obj.id == 1) {
        // let selectedList = this.processedLists.filter(list => list.id == this.model.id)
        // this.model.discount = selectedList[0].discount
        // this.isShowDiscountModal = !this.isShowDiscountModal
        this.$router.push({ name: 'discount', params: { id: obj.item_id }})
      } else {
        // this.isShowCostModal = !this.isShowCostModal
        this.$router.push({ name: 'cost', params: { id: obj.item_id }})
      }
    },
    closeModal() {
      Object.keys(this.model).map(el => {
        el = 'roles' ? this.model[el] = [] : this.model[el] = null
      })

      this.isShowCostModal = false,
      this.isShowRevenueModal = false,
      this.isShowDiscountModal = false
    },
    selectStatus(item){
      this.selectedStatus = item.value
    },
    filterData() {
      this.isEmpty = false
      let array = this.lists

      if (this.searchBoxValue) {
        array = array.filter(list => {
          let listCampaign = list.campaign.toLowerCase()
          let searchValue = this.searchBoxValue.toLowerCase()
          return listCampaign.includes(searchValue)
        })
      }

      if (this.selectedStatus) {
        array = array.filter(list => {
          return list.status.includes(this.selectedStatus)
        })
      }

      this.processedLists = array
      if (!this.processedLists.length) this.isEmpty = true
    },
    formatDate(date){
      return formatShortDate(date)
    },
    addRole() {
      this.isShowRoleModal = true
    },
    closeRoleModal() {
      this.isShowRoleModal = false
    },
    saveNewRole() {
      this.model.roles.push({
        role: this.newRole,
        user: this.newUser,
        share: 0,
      })
      
      this.newRole = null
      this.newUser = null
      this.isShowRoleModal = false
    },
    setRevenueSharing() {
      if (this.model.roles.length) {
        this.model.roles.map(role => {
          let share = parseInt(role.share)/100
          role.share = share
        });
        (async () => {
          let data = {
            id: this.model.id,
            roles: this.model.roles
          }
          const response = await api.post(apiV2.sharingRevenueAdd, data, { needToken: true })
          if (response.status == 201) {
            this.$notify({
              group: 'saved',
              title: status,
              text: 'Data successfully saved.',
              type: 'success'
            })
            this.$router.push({ name: 'revenue', params: { id: data.id }})
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'Sorry something went wrong!',
              type: 'danger'
            })
          }
        })();
      } else {
        this.isShowRevenueModal = false
      }
    },
    setDiscountSharing() {
      if (this.model.roles.length) {
        this.model.roles.map(role => {
          let share = parseInt(role.share)/100
          role.share = share
        });
        (async () => {
          let data = {
            id: this.model.id,
            discount: this.model.discount,
            roles: this.model.roles
          }
          const response = await api.post(apiV2.sharingDiscountAdd, data, { needToken: true })
          if (response.status == 201) {
            this.$notify({
              group: 'saved',
              title: status,
              text: 'Data successfully saved.',
              type: 'success'
            })
            this.$router.push({ name: 'discount', params: { id: data.id }})
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'Sorry something went wrong!',
              type: 'danger'
            })
          }
        })();
      } else {
        this.isShowDiscountModal = false
      }
    },
    setCostSharing() {
      if (this.model.roles.length) {
        this.model.roles.map(role => {
          let share = parseInt(role.share)/100
          role.share = share
        });
        (async () => {
          let data = {
            id: this.model.id,
            name: this.model.costName,
            amount: parseInt(this.model.costAmount),
            roles: this.model.roles
          }
          const response = await api.post(apiV2.sharingCostAdd, data, { needToken: true })
          if (response.status == 201) {
            this.$notify({
              group: 'saved',
              title: status,
              text: 'Data successfully saved.',
              type: 'success'
            })
            this.$router.push({ name: 'cost', params: { id: data.id }})
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'Sorry something went wrong!',
              type: 'danger'
            })
          }
        })();
      } else {
        this.isShowCostModal = false
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
@import '~@/styles/variables';
@import '~@/styles/mixins';

.revenue-sharing {
  .modal {
  
    &__content {
      width: 480px !important;
    }
  }

  .selectDropdown {
    .popup {
      max-height: 150px;
      overflow-y: auto !important;
    }
  }
}
</style>